<template>
    <div>
        <span v-if="priceIndicatorText">
            <status-dot :value="priceIndicatorColour" style="display: inline-block; padding-right: 5px;" />
            {{ priceIndicatorText }}
        </span>
        <span v-else>-</span>
    </div>
</template>

<script>
    import StatusDot from "./StatusDot";

    export default {
        components: {StatusDot},
        props: {
            value: {
                type: [Number, String, Object],
                required: true
            },
            column: {
                type: Object,
                required: true
            }
        },
        computed: {
            priceIndicatorText() {
                return this.value.price_positions[this.column.position + '_indication']
            },
            priceIndicatorColour() {
                switch (this.priceIndicatorText) {
                    case 'Low':
                    case 'Great':
                    case 'Good':
                        return 'green'
                    case 'Fair':
                        return 'orange'
                    case 'High':
                        return 'orange'
                }
            }
        }
    }
</script>